export default __webpack_public_path__ + "static/media/promotionExample.1cd59366.png";